module.exports = __webpack_public_path__ + "img/1d13ab8.png";